export default __webpack_public_path__ + "static/media/step.024665f7.png";